import { gql } from '@apollo/client';

import { convertArrayToGQL } from '@app/query/utils/graphql';

export const applicationGetManyWithPagination = (fields: string[]) => gql`
  query applicationGetManyWithPagination(
    $page: Int!
    $limit: Int!
    $orderBy: [OrderByDto]
    $search: String
    $status: String
    $createdAtLte: String
    $createdAtGte: String  
  ) {
    applicationGetManyWithPagination(
      page: $page
      limit: $limit
      orderBy: $orderBy
      status: $status
      search: $search
      createdAtLte: $createdAtLte
      createdAtGte: $createdAtGte
    ) {
      pagination {
        totalItems
      }
      rows {
          ${convertArrayToGQL(fields, true)}
      }
    }
  }
`;

export const applicationGetOne = (fields: string[]) => {
  return gql`
    query applicationGetOne($id: Int!) {
      applicationGetOne(id: $id) {
        ${convertArrayToGQL(fields, true)}
      }
    }
  `;
};

export const applicationUpdateOne = (fields: string[]) => {
  return gql`
    mutation applicationUpdateOne($input: ApplicationUpdateInput!) {
      applicationUpdateOne(input: $input) {
        ${convertArrayToGQL(fields, true)}
      }
    }
  `;
};

export const APPLICATION_SUBMIT = gql`
  mutation applicationSubmit($input: IdInput!) {
    applicationSubmit(input: $input) {
      id
      status
      isUnlocked
    }
  }
`;

export const APPLICATION_SUBMIT_PHOTOS = gql`
  mutation applicationSubmitPhotos($input: IdInput!) {
    applicationSubmitPhotos(input: $input) {
      id
      isPhotosSubmitted
    }
  }
`;

export const APPLICATION_UPDATE_ATTACH_PHOTOS = gql`
  mutation applicationUpdateOneAttachPhotos($input: ApplicationUpdateAttachPhotosInput!) {
    applicationUpdateOneAttachPhotos(input: $input) {
      id
      photos {
        id
        name
      }
    }
  }
`;

export const APPLICATION_CREATE_NEW_JOURNEY = gql`
  mutation applicationCreateNewJourney($input: IdInput!) {
    applicationCreateNewJourney(input: $input) {
      id
    }
  }
`;

export const APPLICATION_UNLOCK_UPDATE = gql`
  mutation applicationUnlockUpdate($input: IdInput!) {
    applicationUnlockUpdate(input: $input) {
      id
      isUnlocked
    }
  }
`;

export const APPLICATION_LOCK_UPDATE = gql`
  mutation applicationLockUpdate($input: IdInput!) {
    applicationLockUpdate(input: $input) {
      id
      isUnlocked
    }
  }
`;

export const APPLICATION_DELETE_ONE = gql`
  mutation applicationDeleteOne($input: IdInput!) {
    applicationDeleteOne(input: $input)
  }
`;

export const APPLICATION_UPDATE_SURVEY_FLAG = gql`
  mutation applicationUpdateOneSurveyFlag($input: ApplicationUpdateSurveyFlagInput!) {
    applicationUpdateOneSurveyFlag(input: $input) {
      id
      flags
    }
  }
`;

// A fixed shape, not `convertArrayToGQL` — that machinery exists for `applicationGetOne`'s
// survey-driven field list. No codegen checks this: re-read it against the frozen
// PLAN-BACKEND.md §4.7 shape before relying on it — a stale field here is a runtime GraphQL error
// that takes the whole page's data with it, not a compile error.
export const WATCHLIST_GET_ONE_BY_APPLICATION = gql`
  query watchlistGetOneByApplication($applicationId: Int!) {
    watchlistGetOneByApplication(applicationId: $applicationId) {
      id
      status
      generatedAt
      requestedAt
      failureReason
      items {
        id
        ruleId
        title
        justification
      }
    }
  }
`;
